import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const title: SxStyle = {
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const employeeIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const officeIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};
